import { useDroppable } from "@dnd-kit/core";
import { SortableContext, rectSwappingStrategy } from "@dnd-kit/sortable";
import clsx from "clsx";
import { FC, PropsWithChildren } from "react";

import styles from "./droppable.module.scss";

type Props = {
  id: string | number;
  className?: string;
  index?: number;
  items?: Array<string>;
};

const DroppableRow: FC<PropsWithChildren<Props>> = ({
  children,
  id,
  className,
  index,
  items = []
}) => {
  const { isOver, setNodeRef } = useDroppable({
    id,
    data: {
      index
    }
  });

  return (
    <SortableContext strategy={rectSwappingStrategy} items={items}>
      <section
        className={clsx(styles.row, isOver && styles.drop_border, className)}
        ref={setNodeRef}
      >
        {children}
      </section>
    </SortableContext>
  );
};

export default DroppableRow;
